var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div layout=\"row\" layout-align=\"center center\" layout-padding=\"20\">\n<md-card flex-xs=\"grow\" class=\"md-whiteframe-5dp\" layout-align=\"center center\" layout-margin=\"15\" flex-gt-xs=\"60\" flex-gt-sm=\"40\" style=\"height:200px;\">\n<div flex>\n<p>\nYour account has been created successfully.\n</p>\n<div layout=\"row\">\n<md-button class=\"md-raised md-primary md-hue2\" ng-link=\"['SignIn']\">Click here to login.</md-button>\n</div>\n</div>\n</md-card>\n</div>";
var id1="components/public/account-request-completed.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/public/account-request-completed.html
// module id = 681
// module chunks = 0